<div class="cv-release-notes">
	<div class="cv-dialog-box">
		<div class="modal-header">
			<h5 class="modal-title">Newest Release</h5>
			<button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onCloseDialog()">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<div class="release-note-set" *ngIf="releaseNotesOf">
				<div>
					<div class="grid-row">
						<div class="release-version">
							Version: {{releaseNotesOf.version}} | Date: {{releaseNotesOf.date}}
						</div>
					</div>
					<div class="over-flow-content">
						<div class="grid-row sub-section" *ngIf="releaseNotesOf.features && releaseNotesOf.features.length > 0">
							<div class="grid-column note-type">
								<span>Feature</span>
							</div>
							<div class="grid-column note-data note-data-container">
								<div class="grid-row no-border" *ngFor="let note of releaseNotesOf.features">
									<div class="grid-column note-data features">
										<div class="title">{{note.title}}</div>
										<div class="description">{{note.description}}</div>
									</div>
								</div>
							</div>
						</div>
						<div class="grid-row sub-section" *ngIf="releaseNotesOf.fixes && releaseNotesOf.fixes.length > 0">
							<div class="grid-column note-type fixes">
								<span>Fix</span>
							</div>
							<div class="grid-column note-data note-data-container">
								<div class="grid-row no-border" *ngFor="let note of releaseNotesOf.fixes">
									<div class="grid-column note-data">
										<div class="title">{{note.title}}</div>
										<div class="description">{{note.description}}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="onCloseDialog()">Close</button>
		</div>
	</div>
</div>
